import React from "react";

const FIELD_CLASS = "w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400";

export default function ContactSection({ draft, setDraft }) {
  const update = (field) => (e) => setDraft({ ...draft, [field]: e.target.value });
  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-contact">
      <p className="text-sm font-semibold text-white mb-3">Contact Info</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input value={draft.full_name} onChange={update("full_name")} placeholder="Full Name *" data-testid="resume-input-full-name" className={FIELD_CLASS} />
        <input value={draft.target_role} onChange={update("target_role")} placeholder="Target Role (e.g. Data Cloud Consultant)" data-testid="resume-input-target-role" className={FIELD_CLASS} />
        <input value={draft.contact_email} onChange={update("contact_email")} placeholder="Email" data-testid="resume-input-email" className={FIELD_CLASS} />
        <input value={draft.contact_phone} onChange={update("contact_phone")} placeholder="Phone" data-testid="resume-input-phone" className={FIELD_CLASS} />
        <input value={draft.location} onChange={update("location")} placeholder="Location (City, Country)" data-testid="resume-input-location" className={FIELD_CLASS + " sm:col-span-2"} />
      </div>
    </div>
  );
}
